import { Directive } from '@angular/core';

@Directive({
  selector: '[appGetTitle]',
})
export class GetTitleDirective {
  title: string;
  constructor() {}
}
